import { createFileRoute } from "@tanstack/react-router"
import { teamSettingsViewStaticData } from "src/views/TeamSettingsView/constants"
import { TeamSettingsView } from "src/views/TeamSettingsView/TeamSettingsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/teams/")({
	component: TeamSettingsView,
	staticData: teamSettingsViewStaticData,
})
